import { render, staticRenderFns } from "./GroupLeave.vue?vue&type=template&id=1a83b600&"
import script from "./GroupLeave.vue?vue&type=script&lang=js&"
export * from "./GroupLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports